import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/OversizeDeterminationWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Sieves.CumulativeWetMassRetainedPercent`]: { format: { nearest: 1 } },
    },
    getLabelConfig(prefix),
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 1, defaultUom: 'g' },
    }
  );

export { getConfig };

export default {
  [qestIds.oversizeDetermination.AS_1289_5_1_1]: getConfig,
};
